//INFODIGITAAL kleur is geel, INFOPAPIER kleur is oranje
export enum MeldingType {
  ERROR = 'ERROR',
  SUCCES = 'SUCCES',
  WAITING = 'WAITING',
  INFO_DIGITALEAFGIFTE = 'INFODIGITAAL',
  INFO_PAPIERENAFGIFTE = 'INFOPAPIER',
}

export interface EcertMelding {
  id?: string;
  header: string;
  melding: string;
  type?: MeldingType;
  parseMelding?: boolean;
  permanent?: boolean;
  isPopup?: boolean;
  bestemming?: string;
  ouderComponent?: string;
  bestand?: string;
  metSluitknop?: boolean;
  meldingParameter?: { [key: string]: any };
  eenmaligTonen?: boolean;
}
